import { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "../../../../app";

const useOrganizationAvatar = () => {
  const { user } = useAppSelector((state) => state.userReducer);
  const [image, setImage] = useState("");

  const organizationName = user?.organization?.name;

  const loadImage = useCallback(
    async (controller: AbortController): Promise<void> => {
      try {
        if (
          user?.organization.settings.metaData?.logoUrl &&
          user.organization.name.toLowerCase() !== "klassifai"
        ) {
          setImage(user?.organization.settings.metaData.logoUrl);
          return;
        }

        const file = await import("../../../assets/klassifaiWhiteIcon.svg");
        const response = await fetch(file.default, {
          signal: controller.signal,
        });
        const data = response.url;
        setImage(data);
      } catch (e) {
        console.log(e);
      }
    },
    [user],
  );

  useEffect(() => {
    if (!user?.organization?.name) {
      return;
    }

    const controller = new AbortController();
    // loadImage mixes an async path (setImage after awaiting the icon
    // import/fetch, which the rule cannot see through) with one synchronous
    // branch for a configured organization logo. Deriving the logo branch
    // instead would change the first painted frame and the behaviour when
    // switching organizations, which is not worth the risk for an avatar.
    // eslint-disable-next-line react-hooks/set-state-in-effect -- see above
    loadImage(controller);

    return () => {
      controller.abort();
    };
  }, [user, loadImage]);

  return { image, organizationName };
};

export default useOrganizationAvatar;
